import { ScreenId } from '@core/router'

import { type TScreenName } from '../types/screenNameTypes'

// Router ScreenId (mirrors backend) -> analytics screen name (the value audio-web sent).
// The two are separate on purpose: the name is fixed by the existing dataset, and several product
// screens can report as one. Screens not yet migrated resolve to 'not_supported_screen'.
export const screenNames: Partial<Record<ScreenId, TScreenName>> = {
    [ScreenId.MP3_CUTTER]: 'cutter_main',
    [ScreenId.BROWSE]: 'browse',
    [ScreenId.AUDIO]: 'audio',
    [ScreenId.AUTH]: 'auth',
    [ScreenId.FORGOT_PASSWORD]: 'auth',
    [ScreenId.SEARCH]: 'search',
    [ScreenId.COLLECTION]: 'collection',
    [ScreenId.USER_AUDIO]: 'user_audio',
    [ScreenId.USER_COLLECTIONS]: 'user_collections',
    [ScreenId.AUDIO_UPLOAD]: 'audio_upload',
    [ScreenId.AUDIO_EDIT]: 'audio_edit',
    [ScreenId.ERROR]: 'not_found',
    [ScreenId.AUDIO_NOT_FOUND]: 'audio',
}
